module.exports = __webpack_public_path__ + "static/media/dbanre.de828d63.jpg";